import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'reducers';
import { Constants } from 'utils';
import { Redirect } from 'react-router-dom';

const Home = () => {
	const user = useSelector((state: RootState) => state.user);

	if (!user) {
		return <Redirect to="/client/quotes/request" />
	}
	else {
		switch(user?.level_id) {
			case Constants.LEVELS.ADMIN:
				return <Redirect to="/admin" />
			break;

			case Constants.LEVELS.MODERATOR:
				return <Redirect to="/admin" />
			break;

			case Constants.LEVELS.CLIENT:
				return <Redirect to="/home" />
			break;

			default:
				return <Redirect to="/home" />
			break;
		}
	}
}

export default Home;